module.exports = __webpack_public_path__ + "95eb2ae2ffbae74a80bb25982b3d3f32.png";